// شمسٌ تضحك في الصبح، وقمرٌ نائم بالليل (قرار المالك 22/09/2026: «حط شمس بتضحك الصبح
// وبالليل حط قمر نايم»).
//
// **ورسمٌ لا رمز تعبيري**: الإيموجي يختلف شكلُه من جهازٍ لجهاز — على ويندوز غيرُه على
// الأندرويد غيرُه على الآيفون — و«الشمس اللي بتضحك» قد تصير قرصًا أصفر بلا وجه. والرسم
// هنا واحدٌ عند الجميع، ويأخذ ألوانه من ألوان البرنامج لا من لوحة النظام.
//
// **وينقسم على نفس الساعة**: السادسة مساءً هي فاصل التحيّة نفسِها (`timeGreetingAr`)،
// فلا يُقال «صباح الخير» تحت قمرٍ نائم.
//
// والحركةُ هادئة وتتوقّف لمن طلب تقليل الحركة (`motion-reduce`) — هي زينةٌ لا خبر.
import { isDaytimeCairo } from '../lib/greeting.ts';

export function GreetingIcon({ at = new Date(), className = '' }: { at?: Date; className?: string }) {
  const day = isDaytimeCairo(at);
  return (
    <span aria-hidden="true" className={`inline-block shrink-0 align-middle ${className}`}>
      {day ? <Sun /> : <Moon />}
    </span>
  );
}

/** شمسٌ تضحك: قرصٌ بوجهٍ ضاحك وأشعّةٌ تدور ببطء. */
function Sun() {
  return (
    <svg viewBox="0 0 48 48" className="h-9 w-9" role="img">
      <g className="origin-center motion-safe:animate-[spin_18s_linear_infinite]" stroke="#f59e0b" strokeWidth="2.6" strokeLinecap="round">
        {[0, 45, 90, 135, 180, 225, 270, 315].map(a => (
          <line key={a} x1="24" y1="3.5" x2="24" y2="8.5" transform={`rotate(${a} 24 24)`} />
        ))}
      </g>
      <circle cx="24" cy="24" r="12" fill="#fbbf24" stroke="#f59e0b" strokeWidth="1.5" />
      {/* عينان ضاحكتان: قوسان لا نقطتان — الضحك في العين قبل الفم */}
      <path d="M17.5 21.5q1.8-2.2 3.6 0M26.9 21.5q1.8-2.2 3.6 0" fill="none" stroke="#7c2d12" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M18.5 27q5.5 4.6 11 0" fill="none" stroke="#7c2d12" strokeWidth="1.9" strokeLinecap="round" />
      <circle cx="15.8" cy="26.6" r="1.7" fill="#fb7185" opacity=".55" />
      <circle cx="32.2" cy="26.6" r="1.7" fill="#fb7185" opacity=".55" />
    </svg>
  );
}

/** قمرٌ نائم: هلالٌ بعينٍ مغمضة وفمٍ هادئ، وفوقه «z z z» تصعد. */
function Moon() {
  return (
    <svg viewBox="0 0 48 48" className="h-9 w-9" role="img">
      <path d="M33 30.5A14 14 0 0 1 17.5 9a14.5 14.5 0 1 0 15.5 21.5Z" fill="#cbd5e1" stroke="#94a3b8" strokeWidth="1.4" />
      {/* عينٌ مغمضة وفمٌ ساكن — على الجهة المضيئة من الهلال */}
      <path d="M17 26.5q2.2 2 4.4 0" fill="none" stroke="#475569" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M24.5 30.5q1.6 1.2 3.2 0" fill="none" stroke="#475569" strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="15" cy="31" r="1.6" fill="#fb7185" opacity=".45" />
      <g fill="#64748b" fontFamily="system-ui, sans-serif" fontWeight="700">
        <text x="33" y="14" fontSize="9" className="motion-safe:animate-pulse">z</text>
        <text x="39" y="9" fontSize="7" opacity=".7" className="motion-safe:animate-pulse">z</text>
      </g>
    </svg>
  );
}
